import { connect } from 'react-redux';
import PostRequestModal from './PostRequestModal';
import { isLoadingSelector } from '../../../modules/LoadingStatus/reducer';

const mapStateToProps = (state, ownProps) => ({
  isLoading: isLoadingSelector(state, ownProps.loadingSelector),
});

export default connect(mapStateToProps)(PostRequestModal);
